import React from 'react';
import {
    Switch,
    Route,
    useRouteMatch,
    Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';
import Container from '@mui/material/Container';

import TabPanel from '../../components/TabPanel';
import AppSidebar from '../../components/Sidebar/AppSidebar';
import { ListingIcon, TradeIcon } from '../../components/Sidebar/sidebarIcons';

import ListRoutes from './ListRoutes';
import TradeRoutes from './TradeRoutes';

const ListRoutesContainer = (props) => {
    let { path } = useRouteMatch();

    let demo;
    let vEmail;
    try {
        demo = props.profile.demo;
        vEmail = localStorage
            .getItem('user-email')
            .includes('veronica@curzioresearch.com');
    } catch (e) {
        demo = null;
        vEmail = null;
    }

    const sidebarGroups = [
        {
            key: 'list',
            label: 'List',
            icon: <ListingIcon />,
            children: [
                { label: 'Overview', path: `${path}/list`, exact: true },
                { label: 'Disclosure Requirements', path: `${path}/list/disclosure-requirements` },
                ...(demo || vEmail
                    ? [{ label: 'Listing Advisor Update', path: `${path}/list/sponsor-advisor-updates` }]
                    : []),
                { label: 'Documents/Templates', path: `${path}/list/documents-templates` },
                { label: 'Listing Details', path: `${path}/list/listing-details` },
                { label: 'Verified Partners', path: `${path}/list/verified-partners` },
            ],
        },
        {
            key: 'trade',
            label: 'Trade',
            icon: <TradeIcon />,
            children: [
                { label: 'Overview', path: `${path}/trade`, exact: true },
                { label: 'History', path: `${path}/trade/history` },
            ],
        },
    ];

    return (
        <Container maxWidth={false} disableGutters>
            <div className="idb-issue-shell">
                <AppSidebar
                    sections={[
                        { key: 'issue', label: 'Issue', path: '/issuer/issue' },
                        { key: 'list', label: 'List', path: '/issuer/list' },
                    ]}
                    groups={sidebarGroups}
                />
                <div className="idb-issue-content">
                    <TabPanel>
                        <Switch>
                            <Route exact path={`${path}/`}>
                                <Redirect to={`${path}/list`} />
                            </Route>
                            <Route path={`${path}/list`} component={ListRoutes} />
                            <Route path={`${path}/trade`} component={TradeRoutes} />
                        </Switch>
                    </TabPanel>
                </div>
            </div>
        </Container>
    );
};

const mapStateToProps = ({ profile }) => {
    return {
        profile: profile,
    };
};

export default connect(mapStateToProps, null)(ListRoutesContainer);
